import { Column } from '@shared';

export class Category {
  @Column({
    title: 'Id',
    field: 'id',
    order: 0.1,
    width: 10,
    sortable: true,
    visibleInQuickView: true,
    filterable: true,
    filterType: 'numeric',
  })
  id: string = '';
  @Column({
    title: 'Category Name',
    field: 'name',
    order: 0.1,
    width: 26,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
    filterable: true,
    filterType: 'text',
  })
  name?: string = '';

  @Column({
    title: 'Is Active',
    field: 'isActive',
    order: 0.1,
    width: 18,
    visibleInQuickView: true,
    filterable: true,
    editable: true,
    filterType: 'boolean',
    type: 'boolean',
    filterOptions: [
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ],
    sortable: true,
  })
  isActive: boolean = false;

  @Column({
    title: 'Item Count',
    field: 'itemCount',
    order: 0.1,
    width: 16,
    sortable: true,
    visibleInQuickView: true,
    filterable: true,
    filterType: 'numeric',
  })
  itemCount: number;

  @Column({
    title: 'Sort Order',
    field: 'sortOrder',
    order: 0.1,
    width: 20,
    sortable: true,
    visibleInQuickView: true,
    filterable: true,
    filterType: 'numeric',
  })
  sortOrder?: number = 0;

  constructor(category?: Partial<Category>) {
    this.id = category?.id || '0';
    this.name = category?.name || '';
    this.isActive = category?.isActive || false;
    this.itemCount = category?.itemCount || 0;
    this.sortOrder = category?.sortOrder;
  }
}
